import styled from "styled-components";

const InteractiveText = styled.div<{ fontSize?: string }>`
  font-size: ${({ fontSize }) => fontSize || "large"};
  text-decoration: underline;
  cursor: pointer;
`;

export default InteractiveText;
